<form [formGroup]="form">
    <mat-form-field class="full-width">
        <mat-label>Paciente</mat-label>
        <input type="text" #patientCtrl formControlName="PatientCtrl" matInput placeholder="Busque al paciente por apellido, nombre o documento" (input)="onPatientChange($event.target.value)" [matAutocomplete]="autPatient">
        <mat-autocomplete #autPatient="matAutocomplete" (optionSelected)="patientSelected($event.option.value)" [displayWith]="displayFn">
            <mat-option *ngFor="let patient of patients" [value]="patient">
                <div>
                    <b>{{patient.LastName}}</b>, {{patient.FirstName}}
                </div>
            </mat-option>
        </mat-autocomplete>
        <mat-spinner *ngIf="loading" matSuffix [diameter]="20"></mat-spinner>
    </mat-form-field>
</form>